import LatticeMiniIcon from './LatticeMiniIcon'

export default LatticeMiniIcon
